import "../../../../assets/css/AddCatalogs.css";
import React, { useEffect, useState } from "react";
import MainBoxDefault from "./MainBoxDefault";
import MainBoxUpdateMembership from "./MainBoxUpdateMembership";
import { useSelector } from "react-redux";
import { Appstore } from "../../../../redux";
import { normalizeMembershipStatus, type MembershipStatusLabel } from "../../../../utils/membershipStatus";

interface IMainBoxProps {
}

type MembershipDetailsState = {
  membershipStatus?: MembershipStatusLabel | "";
  membershipType?: string;
  serviceType?: string;
  logo?: string;
  name?: string;
};

const MainBox: React.FC<IMainBoxProps> = ({ ...props }) => {
  const [updateMembership, setUpdateMembership] = useState(false);
  const manageFirm = useSelector((state: Appstore) => state.manageFirm);

  const [membershipDetails, setMembershipDetails] = useState<MembershipDetailsState>({
    membershipStatus: manageFirm.selectedFirm?.membershipStatus
      ? normalizeMembershipStatus(manageFirm.selectedFirm.membershipStatus)
      : undefined,
    membershipType: manageFirm.selectedFirm?.membershipType,
    serviceType: manageFirm.selectedFirm?.serviceType,
    logo: manageFirm.selectedFirm?.logo,
    name: manageFirm.selectedFirm?.name,
  });

  useEffect(() => {
    if (!manageFirm.selectedFirm) {
      return;
    }
    setMembershipDetails({
      membershipStatus: normalizeMembershipStatus(
        manageFirm.selectedFirm.membershipStatus,
      ),
      membershipType: manageFirm.selectedFirm.membershipType,
      serviceType: manageFirm.selectedFirm.serviceType,
      logo: manageFirm.selectedFirm.logo,
      name: manageFirm.selectedFirm.name,
    });
  }, [
    manageFirm.selectedFirm?.id,
    manageFirm.selectedFirm?.membershipStatus,
    manageFirm.selectedFirm?.membershipType,
  ]);

  const handleSaveMembership = (updatedDetails: any) => {
    setMembershipDetails((prevDetails) => ({
      ...prevDetails,
      ...updatedDetails,
      membershipStatus: normalizeMembershipStatus(
        updatedDetails?.membershipStatus,
      ),
    }));
    setUpdateMembership(false);
  };

  return (
    <>
      <article className="articleSection relative">
        {updateMembership ? (
          <MainBoxUpdateMembership
            membershipDetails={membershipDetails}
            setUpdateMembership={setUpdateMembership}
            onSaveMembership={handleSaveMembership}
          />
        ) : (
          <MainBoxDefault
            membershipDetails={membershipDetails}
            setUpdateMembership={setUpdateMembership}
          />
        )}
      </article>
    </>
  );
};

export default MainBox;
